/**
 * @generated SignedSource<<2f7a42d19f4ce290ac3ddeb30386f519>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsSidebar_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersFragment_session">;
  readonly " $fragmentType": "LessonsSidebar_session";
};
export type LessonsSidebar_session$key = {
  readonly " $data"?: LessonsSidebar_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsSidebar_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsSidebar_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonsFiltersFragment_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "0bfd30652b4e5421a5a8a68c636d741d";

export default node;
